import { atomWithKey as atom } from "./atomWithKey";
import { IPendingVouchers, IVoucherData } from "../Types/Interface/IVoucher";
import { IVoucherDetail } from "../Types/Interface/IVoucherDetail";

export const voucherCodeAtom = atom<string>({
    key: "voucherCodeAtom",
    default: "",
});
export const voucherErrorAtom = atom<string>({
    key: "voucherErrorAtom",
    default: "",
});
export const listOfAppliedVoucherAtom = atom<IPendingVouchers[]>({
    key: "listOfAppliedVoucherAtom",
    default: [],
});
export const voucherDataAtom = atom<IVoucherData[]>({
    key: "voucherDataAtom",
    default: [],
});

export const voucherDetailAtom = atom<IVoucherDetail>({
    key: "voucherDetailAtom",
    default: {} as IVoucherDetail,
});

export const voucherStateAtom = atom({
    key: "voucherState",
    default: {
        code: null as string | null,
        discountAmount: 0 as number,
    },
});